import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	moveTo: {
		id: 'backlog.card-list.card.context-menu.move-to',
		defaultMessage: 'Move to',
		description: 'Label for context menu action to move a card to another list',
	},
	topOfTheBacklog: {
		id: 'backlog.card-list.card.context-menu.top-of-the-backlog',
		defaultMessage: 'Top of backlog',
		description: 'Label for context menu action to move a card to the top of the backlog',
	},
	bottomOfTheBacklog: {
		id: 'backlog.card-list.card.context-menu.bottom-of-the-backlog',
		defaultMessage: 'Bottom of backlog',
		description: 'Label for context menu action to move a card to the bottom of the backlog',
	},
	board: {
		id: 'backlog.card-list.card.context-menu.board',
		defaultMessage: 'Board',
		description: 'Label for context menu action to move a card to the board',
	},
	delete: {
		id: 'backlog.card-list.card.context-menu.delete',
		defaultMessage: 'Delete',
		description: 'Label for context menu action to delete a card',
	},
	archive: {
		id: 'backlog.card-list.card.context-menu.archive',
		defaultMessage: 'Archive',
		description: 'Label for context menu action to archive a card',
	},
	flag: {
		id: 'backlog.card-list.card.context-menu.flag',
		defaultMessage: 'Flag',
		description: 'Label for context menu action to flag or remove flag from a card',
	},
	addFlag: {
		id: 'backlog.card-list.card.context-menu.add-flag',
		defaultMessage: 'Add flag',
		description: 'Label for context menu action to add a flag',
	},
	removeFlag: {
		id: 'backlog.card-list.card.context-menu.remove-flag',
		defaultMessage: 'Remove flag',
		description: 'Label for context menu action to remove a flag',
	},
	copyIssueLink: {
		id: 'backlog.card-list.card.context-menu.copy-issue-link',
		defaultMessage: 'Copy issue link',
		description: 'Label for context menu action to copy the selected issue link',
	},
	copyIssueKey: {
		id: 'backlog.card-list.card.context-menu.copy-issue-key',
		defaultMessage: 'Copy issue key',
		description: 'Label for context menu action to copy the selected issue key',
	},
	viewInIssueSearch: {
		id: 'backlog.card-list.card.context-menu.view-in-issue-search',
		defaultMessage: 'View in issue search',
		description: 'Label for context menu action to view selected issues in issue search.',
	},
	splitIssue: {
		id: 'backlog.card-list.card.context-menu.split-issue',
		defaultMessage: 'Split issue',
		description: 'Label for context menu action to split a single issue into multiple issues',
	},
	addIssueParent: {
		id: 'backlog.card-list.card.context-menu.add-issue-parent',
		defaultMessage: 'Add parent',
		description: 'Label for context menu action to add a parent to the selected issue(s).',
	},
	changeIssueParent: {
		id: 'backlog.card-list.card.context-menu.change-issue-parent',
		defaultMessage: 'Change parent',
		description: 'Label for context menu action to change the parent of the selected issue(s).',
	},
	parentOptionLabel: {
		id: 'backlog.card-list.card.context-menu.parent-option-label',
		defaultMessage: 'Parent',
		description:
			'Label for context menu action to change or remove the parent of the selected issue(s)',
	},
	parentUnlinkOptionLabel: {
		id: 'backlog.card-list.card.context-menu.parent-unlink-option-label',
		defaultMessage: 'Unlink',
		description:
			'Label for option to remove a parent from the selected issue(s) in the context menu parent sub menu',
	},
	versionOptionLabel: {
		id: 'backlog.card-list.card.context-menu.version-option-label',
		defaultMessage: 'Version',
		description:
			'Label for context menu action to change or remove the versions of the selected issue(s)',
	},
	versionUnlinkOptionLabel: {
		id: 'backlog.card-list.card.context-menu.version-unlink-option-label',
		defaultMessage: 'Unlink',
		description:
			'Label for option to remove versions from the selected issue(s) in the context menu parent sub menu',
	},
	originalEstimate: {
		id: 'backlog.card-list.card.context-menu.original-estimate',
		defaultMessage: 'Original estimate',
		description:
			'Label for context menu action to change the original estimate field of the selected issue(s).',
	},
	storyPointEstimate: {
		id: 'backlog.card-list.card.context-menu.story-point-estimate',
		defaultMessage: 'Story point estimate',
		description:
			'Label for context menu action to change the story point estimate field of the selected issue(s).',
	},
	priority: {
		id: 'backlog.card-list.card.context-menu.priority',
		defaultMessage: 'Priority',
		description: 'Label for context menu action to update the priority of multiple issues',
	},
	assignee: {
		id: 'backlog.card-list.card.context-menu.assignee',
		defaultMessage: 'Assignee',
		description: 'Label for context menu action to update the assignee of multiple issues',
	},
	assignToMe: {
		id: 'backlog.card-list.card.context-menu.assign-to-me',
		defaultMessage: 'Assign to me',
		description:
			'Label for an option in the assignee menu, when selected, will assign the issue to the current user',
	},
	bulkChange: {
		id: 'backlog.card-list.card.context-menu.bulk-change',
		defaultMessage: 'Bulk change',
		description:
			'Label for context menu action to go to bulk editor screen with the selected issues(s)',
	},
	goToBulkEditorIconLabel: {
		id: 'backlog.card-list.card.context-menu.go-to-bulk-editor-icon-label',
		defaultMessage: 'Open in new window',
		description:
			'Label for the icon displayed in the context menu action to go to bulk editor screen with the selected issues(s). The icon indicates that the action will open a new browser window.',
	},
	menuTriggerOneCard: {
		id: 'backlog.card-list.card.context-menu.menu-trigger-one-card',
		defaultMessage: 'More actions for {issueKey} {summary}',
		description:
			'Label for meatball menu button which open list with issue actions (one card selected)',
	},
	menuTriggerMoreCards: {
		id: 'backlog.card-list.card.context-menu.menu-trigger-more-cards',
		defaultMessage: 'More actions for {issueKey} {summary} and other selected issues',
		description:
			'Label for meatball menu button which open list with issue actions(more that one card selected)',
	},
	rankUp: {
		id: 'backlog.card-list.card.context-menu.rank-up',
		defaultMessage: 'Move up',
		description: 'Label for ranking cards up',
	},
	rankDown: {
		id: 'backlog.card-list.card.context-menu.rank-down',
		defaultMessage: 'Move down',
		description: 'Label for ranking cards up',
	},
	copyIssueKeySuccessTitle: {
		id: 'backlog.card-list.card.context-menu.copy-issue-key-success-title',
		defaultMessage: 'Issue key copied',
		description: 'Title for success flag when issue key has been copied to clipboard',
	},
	copyIssueKeySuccessDescription: {
		id: 'backlog.card-list.card.context-menu.copy-issue-key-success-description',
		defaultMessage: 'Issue key successfully copied to your clipboard',
		description: 'Description for success flag when issue key has been copied to clipboard',
	},
	ariaLabel: {
		id: 'backlog.card-list.card.context-menu.aria-label',
		defaultMessage: 'Select assignee',
		description: 'Aria-label message for search input',
	},
	sprintSearchPlaceholder: {
		id: 'backlog.card-list.card.context-menu.sprint-search-placeholder',
		defaultMessage: 'Search sprints',
		description: 'Aria-label message for search sprints input',
	},
	copyIssueLinkIssueTermRefresh: {
		id: 'backlog.card-list.card.context-menu.copy-issue-link-issue-term-refresh',
		defaultMessage: 'Copy issue link',
		description: 'Label for context menu action to copy the selected issue link',
	},
	copyIssueKeyIssueTermRefresh: {
		id: 'backlog.card-list.card.context-menu.copy-issue-key-issue-term-refresh',
		defaultMessage: 'Copy issue key',
		description: 'Label for context menu action to copy the selected issue key',
	},
	viewInIssueSearchIssueTermRefresh: {
		id: 'backlog.card-list.card.context-menu.view-in-issue-search-issue-term-refresh',
		defaultMessage: 'View in issue search',
		description: 'Label for context menu action to view selected issues in issue search.',
	},
	splitIssueIssueTermRefresh: {
		id: 'backlog.card-list.card.context-menu.split-issue-issue-term-refresh',
		defaultMessage: 'Split issue',
		description: 'Label for context menu action to split a single issue into multiple issues',
	},
	menuTriggerOneCardIssueTermRefresh: {
		id: 'backlog.card-list.card.context-menu.menu-trigger-one-card-issue-term-refresh',
		defaultMessage: 'More actions for {issueKey} {summary}',
		description:
			'Label for meatball menu button which open list with issue actions (one card selected)',
	},
	menuTriggerMoreCardsIssueTermRefresh: {
		id: 'backlog.card-list.card.context-menu.menu-trigger-more-cards-issue-term-refresh',
		defaultMessage: 'More actions for {issueKey} {summary} and other selected issues',
		description:
			'Label for meatball menu button which open list with issue actions(more that one card selected)',
	},
	copyIssueKeySuccessTitleIssueTermRefresh: {
		id: 'backlog.card-list.card.context-menu.copy-issue-key-success-title-issue-term-refresh',
		defaultMessage: 'Issue key copied',
		description: 'Title for success flag when issue key has been copied to clipboard',
	},
	copyIssueKeySuccessDescriptionIssueTermRefresh: {
		id: 'backlog.card-list.card.context-menu.copy-issue-key-success-description-issue-term-refresh',
		defaultMessage: 'Issue key successfully copied to your clipboard',
		description: 'Description for success flag when issue key has been copied to clipboard',
	},
});
